import { FETCH_ATTENDANCES, FETCH_ATTENDANCES_SUCCESS, FETCH_ATTENDANCES_FAILURE, SAVE_ATTENDANCES_SUCCESS,
  SAVE_ATTENDANCES_FAILURE, ATTENDANCES_AJAX_CALL, ATTENDANCES_CLEAR_AJAX_CALL }
  from '../actions/Attendances'

const initialState = {
  dates: null,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function attendances (state = initialState, action) {
  switch (action.type) {
    case FETCH_ATTENDANCES:
      return {...state, ajaxSpinner: true, error: null, dates: null}
    case FETCH_ATTENDANCES_SUCCESS:
      return {...state, dates: action.payload, ajaxSpinner: false, ajaxStatus: null}
    case FETCH_ATTENDANCES_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false, dates: null}
    case SAVE_ATTENDANCES_SUCCESS:
      return {...state,
        dates: ((state.dates.findIndex(x => x.id === action.payload.id) === -1)
          ? state.dates.concat(action.payload)
          : state.dates.map((item) => {
            return (item.id === action.payload.id) ? action.payload : item
          })),
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_ATTENDANCES_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case ATTENDANCES_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case ATTENDANCES_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/attendances.js